import { Script } from 'gatsby';
import { Helmet } from 'react-helmet';

import { usePageContext } from '~components/PageDataProvider/PageDataProvider';

type Props = {
    href: string;
    global: { schema: { inLanguage: string } };
};

const SEOMetaData = ({ href, global }: Props) => {
    const { seo } = usePageContext();
    if (!seo) {
        return null;
    }

    const canonicalUrl = href;

    const {
        title,
        metaDesc,
        schema,
        opengraphDescription,
        opengraphSiteName,
        opengraphTitle,
        opengraphType,
        metaRobotsNofollow,
        metaRobotsNoindex,
    } = seo;

    const { schema: globalSchema } = global || {};
    const objectRaw = schema?.raw
        ? (JSON.parse(schema.raw) as Record<
              string,
              {
                  '@type': string;
                  itemListElement: { [key: string]: string }[];
              }[]
          >)
        : {};

    /*
    const breadCrumbList = objectRaw['@graph']?.filter(item => item['@type'] === 'BreadcrumbList');
    const homeListElement = breadCrumbList[0]?.itemListElement.filter(
        item => item['name'] === 'Home'
    );
    if (homeListElement && homeListElement[0].item === '/') {
        homeListElement[0].item = process.env.GATSBY_SITE_URL + '/medicare/';
    }
    */

    let robots = [
        'max-snippet:-1',
        'max-image-preview:large',
        'max-video-preview:-1',
        metaRobotsNofollow,
        metaRobotsNoindex,
    ].join();

    if (['qa', 'cm'].includes(process.env.GATSBY_EH_ENV)) {
        robots = 'noindex,nofollow';
    }

    return (
        <Helmet>
            <title>{title}</title>
            <link rel="canonical" href={canonicalUrl} />
            <meta name="description" content={metaDesc} />
            <meta name="og:description" content={opengraphDescription} />
            <meta name="og:locale" content={globalSchema?.inLanguage} />
            <meta name="og:title" content={opengraphTitle} />
            <meta name="og:type" content={opengraphType} />
            <meta name="og:url" content={canonicalUrl} />
            <meta name="robots" content={robots} />
            <meta property="og:site_name" content={opengraphSiteName} />
            <Script type="application/ld+json">{JSON.stringify(objectRaw)}</Script>
        </Helmet>
    );
};

export default SEOMetaData;
